import { Avatar, Box, Icon, Typography, useTheme } from '@mui/material';
import { BoxHoverCursor, ColumnFlexBox, FlexBoxFullWidth } from '../common/boxes';
import React from 'react';
import { IAdminUser } from '../../interfaces/adminUser';

interface IProps {
  user: IAdminUser,
  expanded: boolean,
  logoutHandler: () => void,
}

const Logout = ({ user, logoutHandler, expanded }: IProps) => {
  const theme = useTheme();
  return (
    <BoxHoverCursor py={{ mobile: 1, tablet: 2 }} alignItems={'center'} display={'flex'} onClick={logoutHandler}>
      {
        expanded
          ? <>
            <Box ml={{ mobile: 1, tablet: 2 }}>
              <Avatar sx={{ border: `1px solid ${theme.palette.primary.dark}` }}></Avatar>
            </Box>
            <ColumnFlexBox flexGrow={1} m={1}>
              <Box>
                <Typography sx={{ color: theme.palette.text.primary, display: { mobile: 'none', tablet: 'block' } }}>
                  {user.email}
                </Typography>
                <Typography variant={'body2'}>
                  {'Logout'}
                </Typography>
              </Box>
            </ColumnFlexBox>
          </>
          : <FlexBoxFullWidth justifyContent={'flex-start'} pl={1}>
            <Icon sx={{ color: theme.palette.primary.dark }}>logout</Icon>
          </FlexBoxFullWidth>
      }

    </BoxHoverCursor>
  );
};

export default Logout;